/**
 This function is used to determine if the Confluence share dialog button should
 appear for a specific content type (i.e whiteboards/databases and any future
 content types)
*/
export const useIsNewShareEnabled = (contentType: string | null | undefined) => {
	return contentType === 'whiteboard' || contentType === 'embed' || contentType === 'database';
};
